/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";

export default function PlaylistLayout() {
  return (
    <div>
      <div>
        <h2 className="helpHeaderTitle">Creating Playlists </h2>
        <div className="helpContentSection">
          {" "}
          <div className="imageRow mb-3">
            <div className="imageSection">
              {" "}
              <img
                alt=""
                src={require("../../assets/images/helpCenter/playlistCenterImg1.png")}
              />
            </div>
            <div className="imageInfoSection">
              <div className="boldTitle">Make New Playlist</div>
              <div>
                Within the Content Tab, select “Add Content” and drag and drop
                OR upload files from computer drive.
              </div>
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Build Playlist</div>
            <div>
              Drag desired media files from the media library into the open
              section and set their play duration.
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Set or Edit Restrictions (1)</div>
            <div>
              Specific parameters can be set around the play of each individual
              file. Check the boxes to edit its Start/Stop date and time, and
              share of voice - what percentage of the loop each individual file
              should play for.
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Further Customize (2) </div>
            <div>
              In the “Play as” dropdown different parameters can be set for
              Playlist activity. Most of the time the Playlist should Play
              “Sequentially” (rotate in order) and “Single Content” (play a
              single piece of content each time through the loop).
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Contextual Scheduling (3)</div>
            <div>
              Content can be set to play based on the temperature outside.
              Select “Add Context” to set these restrictions.
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Save Playlist (4)</div>
            <div>
              Click "Save as Playlist" for a new Playlist, or "Update Playlist"
              for a previously existing playlist.
            </div>
          </div>
          <img
            alt=""
            src={require("../../assets/images/helpCenter/playlistCenterImg2.png")}
          />
        </div>
      </div>
    </div>
  );
}
